import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="w-full flex justify-center items-center pt-60 lg:pt-44 pb-36">
      <div className=" md:w-3/5 w-4/5 text-center">
        <h1 className="md:text-[16vw] text-8xl font-robout text-[#fafaf6]">
          <span>4</span>
          <span>0</span>
          <span>4</span>
        </h1>
        <p className="xl:text-6xl md:text-5xl text-3xl  mt-2  text-[#fafaf6] font-robout">
          This page could not be found.
        </p>
        <Link to="/"  aria-label="Return to Home">
          <button  aria-label="Return to Home" className="group relative inline-flex h-14  md:mt-12 mt-4 items-center rounded-full px-8 font-semibold text-white bg-transparent overflow-hidden">
            <span className="absolute inset-0 rounded-full bg-[#d78558] transition-transform duration-[1800ms] ease-[cubic-bezier(0.19,1,0.22,1)] scale-100 group-hover:scale-100">
              <span className="absolute left-1/2 top-[-60%] -translate-x-1/2 aspect-square w-[max(200%,10rem)]">
                <span className="absolute inset-0 rounded-full bg-[#a374ff] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#17f1d1] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-100 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
                <span className="absolute inset-0 rounded-full bg-[#d78558] scale-0 group-hover:scale-100 transition-transform duration-[1300ms] delay-200 ease-[cubic-bezier(0.19,1,0.22,1)]"></span>
              </span>
            </span>
            <span className="relative">
              <span className="block group-hover:opacity-0 px-6 font-robout group-hover:-translate-y-[70%] transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                Return to Home
              </span>
              <span className="absolute gap-2 top-0 left-6  opacity-0 font-robout translate-y-[70%] text-center group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-[1400ms] ease-[cubic-bezier(0.19,1,0.22,1)]">
                Return to Home
              </span>
            </span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
